import { Routes } from '@angular/router';
import { AfterLoginGuard } from './tools/after-login.guard';
import { AuthGuard } from './tools/auth.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'group-members',
    pathMatch: 'full',
  },
  {
    path: 'login',
    loadComponent: () => import('./components/login/login.component').then((m) => m.LoginComponent),
    canActivate: [AfterLoginGuard],
  },
  {
    path: 'mfa-methods-select',
    loadComponent: () => import('./components/login/mfa-method-select/mfa-method-select.component').then((m) => m.MfaMethodSelectComponent),
    canActivate: [AfterLoginGuard],
  },
  {
    path: 'verify-device',
    loadComponent: () => import('./components/login/verify-device.component').then((m) => m.VerifyDeviceComponent),
    canActivate: [AfterLoginGuard],
  },
  {
    path: 'resetpassword',
    loadComponent: () => import('./components/login/reset-password.component').then((m) => m.ResetPasswordComponent),
    canActivate: [AfterLoginGuard],
  },
  {
    path: 'group-members',
    loadComponent: () => import('./components/group-members/group-members.component').then((m) => m.GroupMembersComponent),
    canActivate: [AuthGuard],
  },
  {
    path: 'view-invoice',
    loadComponent: () => import('./components/view-invoice/view-invoice.component').then((m) => m.ViewInvoiceComponent),
    canActivate: [AuthGuard],
  },
  {
    path: 'soa-template',
    loadComponent: () => import('./components/soa-template/soa-template.component').then((m) => m.SOATemplateComponent),
    canActivate: [AuthGuard],
  },

  // all other
  {
    path: '**',
    redirectTo: 'group-members',
    pathMatch: 'full',
  },
];
